import styled from 'styled-components'

import media from 'utils/media'

export const Wrapper = styled.div`
   padding: 24px;
   margin: 24px 0;
   background-color: ${({ theme }) => (theme.darkMode ? theme.colors.menuBg : theme.colors.grey_4)};

   ${media.greaterThan('md')`
      display: flex;
      align-items: center;
      padding: 32px;
      margin: 48px 0;
   `};

   & > div:last-of-type {
      ${media.greaterThan('md')`
         flex: 0 1 50%;
      `};

      ${media.greaterThan('lg')`
         flex: 0 0 296px;
      `};
   }
`

export const StyledText = styled.div`
   margin-bottom: 16px;

   ${media.greaterThan('md')`
      margin-bottom: 0px;
      margin-right: 25px;
      flex: 0 1 50%;
   `};

   ${media.greaterThan('lg')`
      flex: 1;
   `};

   h1,
   h2,
   h3 {
      font-size: 24px;
      line-height: 37px;
      color: ${({ theme }) => theme.colors.hotCinnamon};
      font-family: ${({ theme }) => theme.fonts.sohne};
      font-weight: 700;
      margin-bottom: 4px;
      margin-top: 0;
   }

   p {
      font-size: 16px;
      line-height: 24px;
      font-weight: 300;

      &:last-of-type {
         margin-bottom: 0;
      }
   }
`
